module.exports = __webpack_public_path__ + "img/wholesale-term-modal-image-03.34239d9.svg";